// extracted by mini-css-extract-plugin
export default {"root":"nFQrNA","mobile":"_Qsbmh","title":"mz9udZ","info":"rBVnOp"};